import React, { useState, useEffect } from 'react';
import axios from 'axios';
import QuickMenu from '../../components/QuickMenu/QuickMenu';



export default function Parks() {
  const [parks, setParks] = useState([]);

  useEffect(() => {
    const fetchParks = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/Parks/GetParks`, {});
        if (response.data.isSuccess) {
          setParks(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching parks:', error);
      }
    };

    fetchParks();
  }, []);

  const handleDirections = (location) => {
    const encodedLocation = encodeURIComponent(location);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedLocation}`, '_blank');
  };

  return (
    <main className="main-content">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-md-10">
            <h2 className="page-title">Parklarımız</h2>
            <div className="facilities-grid">
              {parks.map(park => (
                <div key={park.guid} className="facility-card">
                  <div className="facility-image">
                    <img src={park.pictureUrl} alt={park.name} />
                  </div>
                  <div className="facility-content">
                  <div className="facility-content-head">
                  <h3>{park.name}</h3>
                  <p>{park.address}</p>
                  </div>
                  
                    <button 
                      className="directions-button"
                      onClick={() => handleDirections(park.mapUrl)}
                    >
                      Yol Tarifi Al
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
